import { createApp } from 'vue';

// import {
//     createRouter,
//     createMemoryHistory,
//     // createWebHistory,
//     // createWebHashHistory,
// } from 'vue-router';

// import generatedRoutes from 'virtual:generated-pages';
// import { setupLayouts } from 'virtual:generated-layouts';
import App from '~/App.vue';
import { setupRouter } from '~/helpers/router';
import '~/assets/scss/main.scss';
// TODO: for the dark/light mode manual switch
// import { createHead } from '@unhead/vue';

// Bugsnag logging
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import BugsnagPerformance from '@bugsnag/browser-performance';

import { initializeImageMagick } from '@imagemagick/magick-wasm';
import { i18n } from './i18n';

export async function initApp(
    mountPoint: string,
    defaultRoute: string,
    withImageMagick: boolean
) {
    Bugsnag.start({
        apiKey: import.meta.env.VITE_BUGSNAG_PROJECT_API_KEY,
        plugins: [new BugsnagPluginVue()],
        collectUserIp: false,
        // enabledReleaseStages: ['production', 'development'],
        // releaseStage: process.env.NODE_ENV,
        releaseStage: import.meta.env.VITE_MY_ENVIRONMENT,
        onError: function (event) {
            // Fix not sending errors from browser extensions
            // https://github.com/bugsnag/bugsnag-js/issues/94#issuecomment-66153172
            // https://docs.bugsnag.com/platforms/javascript/faq/#how-can-i-get-error-reports-from-browser-extensions
            event.errors[0].stacktrace = event.errors[0].stacktrace.map(
                function (frame) {
                    frame.file = frame.file.replace(
                        /chrome-extension:/g,
                        'chrome_extension:'
                    );
                    frame.file = frame.file.replace(
                        /moz-extension:/g,
                        'moz_extension:'
                    );
                    frame.file = frame.file.replace(
                        /safari-extension:/g,
                        'safari_extension:'
                    );
                    frame.file = frame.file.replace(
                        /safari-web-extension:/g,
                        'safari_web_extension:'
                    );
                    return frame;
                }
            );
        },
    });
    BugsnagPerformance.start({
        apiKey: import.meta.env.VITE_BUGSNAG_PROJECT_API_KEY,
    });

    // H.init('ng2zv0rg', {
    //     environment: 'production',
    //     // version: 'commit:abcdefg12345',
    //     networkRecording: {
    //         enabled: false,
    //         recordHeadersAndBody: true,
    //         urlBlocklist: [
    //             // insert full or partial urls that you don't want to record here
    //             // Out of the box, Highlight will not record these URLs (they can be safely removed):
    //             'https://www.googleapis.com/identitytoolkit',
    //             'https://securetoken.googleapis.com',
    //         ],
    //     },
    // });

    // Note: currently all entry points use the same App.vue.
    // If needed, we can create separate *.vue files for each entry point.
    const app = createApp(App);

    const bugsnagVue = Bugsnag.getPlugin('vue');
    if (bugsnagVue) {
        app.use(bugsnagVue);
    }

    app.use(i18n);

    const router = setupRouter(i18n);

    // const router = createRouter({
    //     history: createMemoryHistory(),
    //     // history: createWebHistory(),
    //     // history: createWebHashHistory(),
    //     routes,
    // });

    app.use(router);

    // Open defaultRoute by default when opening the on-page extension popup
    router.push(defaultRoute);

    // Create a global head instance
    // TODO: for the dark/light mode manual switch
    // const head = createHead();
    // app.use(head);

    if (withImageMagick) {
        const wasmUrl = new URL(
            '@imagemagick/magick-wasm/magick.wasm',
            import.meta.url
        );
        const wasmBuffer = await (await fetch(wasmUrl)).arrayBuffer();
        const wasmArray = new Uint8Array(wasmBuffer);
        await initializeImageMagick(wasmArray);
    }

    app.mount(mountPoint);

    // const wasmLocation = new URL(
    //     '@imagemagick/magick-wasm/magick.wasm',
    //     import.meta.url
    // );
    // initializeImageMagick(wasmLocation).then(() => {
    //     app.mount(mountPoint);
    // });
}
